import React,{useEffect,useState } from "react";
// import {formFieldsAttributes} from '../../Components/FormBuilder/FormBuilderFunctions/FieldProps';
import { isSet } from "../../Utils/CommonFunctions";
import Icons from "../Icons/Icons";
import Wrp from "../../hoc/Wrp/Wrp";


const StepsTypeTagForReminder = (props)=>{

  const [propsValue,setPropsValue] = useState(props.value);

  useEffect( ()=>{    
      let getValue = props.value;
      //console.log('bodyVal===new mail',bodyVal);
      setPropsValue(getValue); 
  }, [props.value]);
 
  //console.log('props.value',props.value);
  return (
      <Wrp>
         <div className='form-control p-0 pt-0' style={{overflow:'hidden'}}>
                      <span className="text-truncate tag-wrapper ReactTags__tag cursor_pointer" title={''}  >
                          <a className="pr-1 cursor_pointer"  onClick={(val)=>props.changeHandler('')}>
                              <Icons iconType='Delete' color='#cfd8dc' size={15} />
                          </a> 
                          {(isSet(props.item.isEditEnable,false)===true)?
                               <a className="pr-1 cursor_pointer" onClick={props.editHandler}>
                                  <Icons iconType='Edit' color='#cfd8dc' size={15} />
                               </a>
                          :<></>}
                         {propsValue}
                         {/* {isSet(attr.value,'').split('.').map((nam,ind)=>{
                          return(
                              <>
                                  <>{nam}</>
                                  <span className="separator"></span>
                                  {isSet(attr.value,'').split('.').length !== ind+1 ?
                                      <span className="separator"> 
                                          <Icons iconType={"SeperatorIcon"} color={'#fff'} size={10}/>
                                      </span>
                                  :<></>}
                          </>
                                                                                      
                        )}) */}
                  {/* } */}
                      </span>
              </div>
         
      </Wrp>
    );
  
}


StepsTypeTagForReminder.defaultProps = {
  className:'form-control'
};

const isDiffProps = (prevProps,nextProps)=>{
  if(prevProps.props.value===nextProps.props.value){
    return true;
  }
}

export default StepsTypeTagForReminder;
